module.exports = __webpack_public_path__ + "static/media/television-symbol.c1c45cb5.svg";